// SDK init: configure base URL once, then re-export the SDK surface.
// Use VITE_API_BASE_URL when present; otherwise default to "/api/v1" so the
// vite dev proxy (configured in vite.config.ts) forwards requests to the
// running backend on :8080. In production builds the dist is served from the
// backend itself so the same-origin "/api/v1" path resolves directly.
import { client } from "@/sdk/client.gen";

const baseUrl = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? "/api/v1";
client.setConfig({ baseUrl });

export { client };
export * from "@/sdk";
